import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";

function AppAutoSelect({
  options = [],
  inputProps,
  errorProps,
  autoSelecboxListConfig,
  loading = false,
  freeSolo = false,
}: any) {
  autoSelecboxListConfig = {
    labelField: "label",
    valueField: "id",
    selectedValueField: "label",
    ...autoSelecboxListConfig,
  };
  const [value, setValue] = useState(inputProps?.value);

  useEffect(() => {
    const filteredValue = options?.find(
      (i) =>
        i?.[autoSelecboxListConfig?.valueField] === inputProps?.value ||
        i?.[autoSelecboxListConfig?.selectedValueField] === inputProps?.value
    );

    if (
      inputProps?.value !== filteredValue?.[autoSelecboxListConfig?.valueField]
    ) {
      const updateValue = filteredValue
        ? filteredValue?.[autoSelecboxListConfig?.valueField]
        : inputProps?.value;

      inputProps.onChange({
        target: {
          name: inputProps?.name,
          value: updateValue,
        },
      });
    }

    setValue(
      filteredValue?.[autoSelecboxListConfig?.labelField] || inputProps?.value
    );
  }, [inputProps?.value]);

  return (
    <Autocomplete
      options={options || []}
      value={value || null}
      id={inputProps?.id}
      loading={loading}
      freeSolo={freeSolo}
      disabled={inputProps?.disabled}
      sx={{ ...inputProps?.sx }}
      getOptionLabel={(option) => {
        return typeof option === "string" && option
          ? option
          : option?.[autoSelecboxListConfig?.labelField] || "";
      }}
      isOptionEqualToValue={(option, value) => {
        return option[autoSelecboxListConfig?.labelField] === value;
      }}
      onChange={(event: any, newValue: any) => {
        inputProps.onChange({
          ...event,
          target: {
            ...event.target,
            name: inputProps.name,
            value: newValue[autoSelecboxListConfig?.valueField],
          },
        });
      }}
      disableClearable
      renderInput={(params) => {
        return (
          <TextField
            name={inputProps?.name}
            variant="outlined"
            aria-describedby={`component-error-text-${inputProps?.id}`}
            fullWidth
            error={errorProps?.error ? true : false}
            value={freeSolo && value}
            onChange={(e) => {
              freeSolo &&
                inputProps?.onChange({
                  ...e,
                  target: {
                    ...e.target,
                    name: inputProps?.name,
                  },
                });
            }}
            {...params}
          />
        );
      }}
    />
  );
}

export { AppAutoSelect };
